import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'
import { LandingCategory } from 'partner360/models/landing/LandingCategory'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

interface IGetProcesses {
  selectedOffering: LandingOffering
  selectedCategory: LandingCategory
  selectedPlanningId: string
  processedPlannings: ILandingProcessedPlanningFetched[]
  selectedStatus: LandingStatus
}

export const getProcesses = ({
  selectedStatus,
  selectedCategory,
  processedPlannings,
  selectedPlanningId,
  selectedOffering,
}: IGetProcesses) => {
  if (selectedOffering === 'Total') {
    return processedPlannings.filter(
      (el) =>
        el.planningId === selectedPlanningId &&
        el.category === selectedCategory &&
        el.status === selectedStatus
    )
  }
  return processedPlannings.filter(
    (el) =>
      el.planningId === selectedPlanningId &&
      el.offering === selectedOffering &&
      el.category === selectedCategory &&
      el.status === selectedStatus
  )
}
